import GlobalPrototypes from '@/config/services/globalPrototypes.ts'

export function useClone() {
  return {
    clone: GlobalPrototypes.clone,
  }
}
